<template>
  <div style="all: initial !important;">
    <react-redoc-wrapper :spec="spec"/>
  </div>
</template>

<script>
import { applyPureReactInVue } from 'veaury';

// This is a React component
import ReactRedocWrapper from './react-redoc-wrapper.react.jsx';

export default {
  name: 'redoc-wrapper',
  props: {
    spec: { type: Object, default: () => ({}) },
  },
  components: {
    'react-redoc-wrapper': applyPureReactInVue(ReactRedocWrapper),
  },
};
</script>

<style scoped>
* {
  all: initial !important;
}
</style>

<style lang="scss">
.redoc-wrap {
  .menu-content {
    top: 54px !important;
  }
}
</style>
